import { render, staticRenderFns } from "./MdopEditMain.vue?vue&type=template&id=72fc3788&scoped=true&"
import script from "./MdopEditMain.vue?vue&type=script&lang=js&"
export * from "./MdopEditMain.vue?vue&type=script&lang=js&"
import style0 from "./MdopEditMain.vue?vue&type=style&index=0&id=72fc3788&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fc3788",
  null
  
)

export default component.exports